module.exports = __webpack_public_path__ + "assets/iphone.a96a6045547b859974dc20801306f957.png";